export default "__VITE_ASSET__JRvw7hw3__"